module.exports = __webpack_public_path__ + "static/img/72.eb15c75c.jpg";